import { isEherkenningCoupled } from './api';
import { makeUrlParams, getQueryParam, clearSessionStorage } from './utils/helpers';
import { redirect } from '@nn/psdl-utility/src/redirect';

export default async (root, config) => {
  const state = getQueryParam('state');
  const code = getQueryParam('code');
  const error = getQueryParam('error');
  const errorDescription = getQueryParam('errorDescription');
  const authId = sessionStorage.getItem('authId');

  const backToLogin = () => redirect(config.eHerkenningCancelPage);
  if (error.length !== 0 || errorDescription.length !== 0 || state.length === 0 || code.length === 0) {
    backToLogin();
  }

  try {
    const { isCoupled, response } = await isEherkenningCoupled(config.urlEherkenningService, state, code, authId);
    if (isCoupled) {
      clearSessionStorage();
      redirect(config.productPage);
    } else {
      sessionStorage.setItem('authId', response.authId);
      sessionStorage.setItem('callbacks', JSON.stringify(response.callbacks));
      redirect(config.eHerkenningCouplingPage + '?' + makeUrlParams({ state, code }));
    }
  } catch (e) {
    backToLogin();
  }
};
